import React from 'react';
import { Box } from '@mui/material';
import { useConsultoriaChat } from '../context/ConsultoriaChatContext';
import { OPS_BACKDROP_Z } from '../constants';
import { getOctoTokens } from '../theme/octoTokens';

/**
 * Dimmer + blur behind the fullscreen chat. Clicking it goes back to the docked
 * panel — the conversation stays on screen; it never hides the chat (P1 task 6).
 * Docked chat never blocks the SaaS background.
 */
export const ConsultoriaShellBackdrop: React.FC = () => {
  const { isPanelOpen, isPanelExpanded, exitPanelExpanded } = useConsultoriaChat();
  const open = isPanelOpen && isPanelExpanded;
  if (!open) return null;

  return (
    <Box
      aria-hidden
      data-harness="backdrop"
      title="Voltar ao painel lateral"
      onClick={exitPanelExpanded}
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: OPS_BACKDROP_Z,
        bgcolor: getOctoTokens('light').color.backdropDim,
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        cursor: 'zoom-out',
      }}
    />
  );
};

export default ConsultoriaShellBackdrop;
